export enum Positions {
  SubGroup = 'positions.subgroup',
}
